export default {
  list: false,
  get: false,
  create: false,
  update: false,
  remove: false
};
